require('./bootstrap');
import Alpine from 'alpinejs';
import Toast from './toast';
import Gallery from './image-gallery';
import BrasilMap from './brasil-map';
import ImageCarousel from './image-carousel';
import Carousel from './carousel';
import './rich-text';

window.Alpine = Alpine;
window.Toast = Toast;
window.Gallery = Gallery;
window.BrasilMap = BrasilMap;
window.ImageCarousel = ImageCarousel;
window.Carousel = Carousel;

Alpine.data('toast', Toast);
Alpine.data('gallery', Gallery);
Alpine.data('brasilMap', BrasilMap);
Alpine.data('imageCarousel', ImageCarousel);
Alpine.data('carousel', Carousel);

Alpine.store('darkMode', {
    dark: false,

    init() {
        this.dark = this.getDarkModeFromDevice() ?? localStorage.dark ?? false;
    },

    toggle() {
        this.dark = !this.dark;
        localStorage.dark = this.dark;
    },

    getDarkModeFromDevice() {
        if (localStorage.dark === 'true' || (!('dark' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
            return true;
        } else {
            return false;
        }
    }
});


window.addEventListener('submittedContactForm', () => dataLayer.push({'event': 'contato-envio'}))

Alpine.start();

const COOKIE_KEY = 'termopiso::cookies-accepted';
const cookieBanner = document.getElementById('cookie-banner');
const acceptCookies = document.getElementById('accept-cookies');
const rejectCookies = document.getElementById('reject-cookies');

if (!localStorage.getItem(COOKIE_KEY) || localStorage.getItem(COOKIE_KEY) === 'false') {
    cookieBanner.style.display = 'block';
} else {
    cookieBanner.style.display = 'none';
}

acceptCookies.addEventListener('click', () => {
    cookieBanner.style.display = 'none';
    localStorage.setItem(COOKIE_KEY, 'true');
});

rejectCookies.addEventListener('click', () => {
    cookieBanner.style.display = 'none';
    localStorage.setItem(COOKIE_KEY, 'false');
})
